export enum ChartType {
  line = 'line',
  doughnut = 'doughnut',
  pie = 'pie',
  horizontalBar = 'horizontalBar',
}
